import React, { useEffect, useState } from "react";
import { string, object } from "prop-types";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import { throttle } from "lodash";

import { AdContainer } from "../../ads";
import "./sticky-banner.m.css";
import { setIsStickyBannerVisible } from "../../store/actions";
import useAdType from "../../helper/useAdType";

const StickyBanner = ({isVisible , showStickyNavbar}) => {
  const pageType = useSelector((state) => get(state, ["qt", "pageType"]));
  const story = useSelector((state) => get(state, ["qt", "data", "story"], {}));
  const tempHideAd =
    story["story-template"] === "brandspot-with-no-ad" ||
    story?.slug?.includes("dhbrandspot-pr/best-crypto-casinos-2025-my-go-to-sites-for-bitcoin-gambling-3470705");

  const [showAd, setShowAd] = useState(true);
  const [isClosed, setClosed] = useState(false);
  // Scroll behaviour change commented - not required for now
  // const [hideOnScroll, setHideOnScroll] = useState(true); // Hidden at top
  // const [bottomNavVisible, setBottomNavVisible] = useState(false); // Track bottom nav visibility
  const dispatch = useDispatch();
  const adType = useAdType();

  if (tempHideAd) return null;

  useEffect(() => {
    if (showAd && !isClosed) {
      dispatch(setIsStickyBannerVisible(true));
    } else {
      dispatch(setIsStickyBannerVisible(false));
    }
  }, [showAd, isClosed]);

  /* Scroll behaviour change commented - not required for now
  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleScrollStateChange = (event) => {
        const { isAtTop, scrollDirection, scrolledToBottom } = event.detail;
        setHideOnScroll(isAtTop);

        if (isAtTop) {
          setBottomNavVisible(false);
        } else if (scrolledToBottom) {
          setBottomNavVisible(true);
        } else if (scrollDirection === "down") {
          setBottomNavVisible(false);
        } else if (scrollDirection === "up") {
          setBottomNavVisible(true);
        }
      };

      window.addEventListener("mobileScrollStateChange", handleScrollStateChange);

      return () => {
        window.removeEventListener("mobileScrollStateChange", handleScrollStateChange);
      };
    }
  }, []);
  */

  const adsId = {
    "story-page": "div-gpt-ad-1680157923413-0",
    "home-page": "div-gpt-ad-1680157033747-0",
    "izooto-sticky": "div-gpt-ad-1711972192178-0"
  };

  const ads = {
    "story-page": "DH_Mweb_AT_Sticky",
    "home-page": "DH_Mweb_HP_Sticky",
    "izooto-sticky": "DH_Mweb_AT_Sticky_ym"
  };

  return (
    <div styleName="wrapper">
      <div id="sticky-ad-banner" styleName={`banner ${isVisible && showAd && !isClosed ? (showStickyNavbar ? "nav-visible" : "") : "hide"}`}>
        <div
          styleName="cross-btn"
          onClick={() => {
            setShowAd(false);
            setClosed(true);
          }}
        >
          &#xd7;
        </div>
        <div styleName="ad-wrapper">
          <span styleName="container-text">ADVERTISEMENT</span>
          <div styleName="sticky-ad">
            <AdContainer
              showText={false}
              id={adType === "izooto" ? adsId["izooto-sticky"] : adsId[pageType] || "div-gpt-ad-1680157033747-0"}
              mobile={adType === "izooto" ? ads["izooto-sticky"] : ads[pageType] || "DH_Mweb_HP_Sticky"}
              isExternalAdPath={adType === "izooto" ? true : false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

StickyBanner.propTypes = {
  pageType: string,
  story: object
};

export default StickyBanner;
